<template>
  <div>
    <div  style="margin-top: 15px;"><!-- display: flex;justify-content: space-between; -->
      <div >
        <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
          <el-tab-pane :label="$t('ACSetting.空调远程预约')" name="first">
            <booking :tabs="activeName"></booking>
            <!-- :activeName="activeName" :Init="true" :type="'0'" -->
          </el-tab-pane>
          <el-tab-pane :label="$t('ACSetting.空调预约记录')" name="second">
            <record :Init="init"></record>
          </el-tab-pane>
        </el-tabs>
      </div>
      
    </div>
    
  </div>
</template>

<script>
import booking from '@/views/vmonitor/ACBooking/booking.vue'
import record from '@/views/vmonitor/ACBooking/record.vue'
export default {
    name:"ACBooking",
  components:{booking,record},
  data(){
    return{
      activeName:"first",
      init:false,
    }
  },
  computed:{
    
  },
  watch: {
    
  },
  methods:{
    handleClick(tabs){
      const {index} = tabs;
      // console.log(index);
      switch(index){
        case "0":
          break;
        case "1":
          this.init = true;
          break;
      }
    },
  },
  created(){
    
  },
  mounted(){
    
  },
  destroyed() {
  },
}
</script>

<style lang="scss"  scoped>
.tabs {
  ::v-deep .el-tabs__item{
    padding: 0 10px !important;    
    font-weight: bold;
    font-size: 14px;
  }
  ::v-deep .el-tabs__nav-wrap {    
    &::after {      
      display: none;    
    }
  }
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px;
  }
}
 
.el-form-item {
    margin-bottom: 0px !important;
}
 
</style>